var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("csp-form-group-select", {
          attrs: {
            form: _vm.damageForm,
            options: _vm.descriptionAccidentOptions,
            "override-invalid-feedback":
              _vm.claimTypeComprehensiveInvalidFeedback,
            "override-state": _vm.claimTypeComprehensiveState,
            property: "descriptionAccident",
            required: "",
          },
        }),
        _vm._v(" "),
        _c("csp-form-group-select", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.canSelectInsuranceType,
              expression: "canSelectInsuranceType",
            },
          ],
          attrs: {
            form: _vm.claimTypeForm,
            options: _vm.claimTypeOptions,
            property: "insuranceType",
            required: "",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }